/* eslint-disable */
import React from 'react';
import Divider from '@material-ui/core/Divider';
import image from '../images/biodefense.jpg';

/**
 * This function renders the Biodefense page
 * @component BiodefensePage
 * @return {Component} BiodefensePage component
 */
export default function BiodefensePage() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: 'white',
        border: '1px solid silver',
      }}
    >
      <div
        style={{
          flex: 1,
          width: '80%',
          margin: '30px auto',
          fontSize: '18px',
          lineHeight: '24px',
        }}
      >
        <h1
          style={{
            paddingLeft: '50px',
            marginBottom: '-40px',
            textTransform: 'uppercase',
          }}
        >
          Be Certain, Not Convinced
        </h1>

        <div style={{ fontSize: '18px', lineHeight: '24px', padding: '50px' }}>
          <Divider />
          <br />
          <p>
            The Advanced Intelligence Services Corporation understands
            military's immediate need for durable, effective physical solutions
            to address the coordination and deployment of metabolic physics
            warfare against U.S. national security interests, worldwide.
          </p>
          <p>
            Since 2003, AIS Corp. Founder Jim D. Ray, Jr. has observed and
            analyzed the ambitious growth trends of the metabolic physics
            communications sector as well as the technology's resounding impacts
            upon the health and safety of the United States. Today, Jim Ray
            continues to be recognized as one of the leading authorities in
            metabolic physics communications protocol, including advancement of
            the technology for use in multi-circa biodefense operations in and
            beyond 2021.
          </p>
          <p>
            Be certain -- not merely convinced -- of the effectivity, integrity,
            and uniquity of the biodefense solutions chosen to safeguard our
            nation's real-time interests, long-term. The Advanced Intelligence
            Services Corporation offers many cutting-edge solutions certain to
            maximize military's goal of practical success in advanced national
            security operations. To learn more, select one of our custom
            products, or consider purchasing a quarterly research subscription
            featuring multi-circa metabolic physics research and development
            reports exclusive to the U.S. Department of Defense.
          </p>
        </div>
      </div>
      <div
        style={{
          background: `url(https://user-images.githubusercontent.com/59159608/110878681-9ffa5880-82a9-11eb-97a2-d3a9c7cd3917.png)`,
          backgroundColor: 'black',
        }}
      >
        <img style={{ width: '600px' }} src={image}></img>
      </div>
    </div>
  );
}
